// First, we import the environment variables so they are available everywhere
import('./environment.gen');

// Then we import the application
import('./app');
